import {DeclarationCotisation} from "@/router/Impression/DeclarationCotisation";
import {DeclarationCotisationOld} from "@/router/Impression/DeclarationCotisationOld";
import {DeclarationCotisationCacobath} from "@/router/Impression/DeclarationCotisationCacobath";
import {CnasDeclarationAnnuelle} from "@/router/Impression/CnasDeclarationAnnuelle";
import {MouvementPersonnel} from "@/router/Impression/MouvementPersonnel";
import {VerificationCaisses} from "@/router/Impression/VerificationCaisses";
import {DeclarationIrg301Bis} from "@/router/Impression/DeclarationIrg301Bis";

export const Impression = {
    path: '/impression',
    name: 'impression',
    component: () => import('@/views/Impression/ImpressionPage.vue'),
    children: [
        DeclarationCotisation,
        DeclarationCotisationOld,
        DeclarationCotisationCacobath,
        MouvementPersonnel,
        CnasDeclarationAnnuelle,
        VerificationCaisses,
        DeclarationIrg301Bis,
    ]
}